"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var buttonStyleActive = function (comp, type) {
    var _a, _b, _c, _d, _e, _f;
    var tmpFontFamily = ((_b = (_a = comp === null || comp === void 0 ? void 0 : comp.collapse[type]) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.fontFamily) ? "font-family: " + ((_d = (_c = comp === null || comp === void 0 ? void 0 : comp.collapse[type]) === null || _c === void 0 ? void 0 : _c.header) === null || _d === void 0 ? void 0 : _d.fontFamily) + ";"
        : '';
    var tmpFontWeight = "font-weight: " + (((_f = (_e = comp === null || comp === void 0 ? void 0 : comp.collapse[type]) === null || _e === void 0 ? void 0 : _e.header) === null || _f === void 0 ? void 0 : _f.fontWeight) || 'bold') + ";";
    return "" + tmpFontFamily + tmpFontWeight;
};
exports.default = buttonStyleActive;
//# sourceMappingURL=utils.js.map